export default [
    {
        path: "/admin/citizenship-statistics",
        name: "citizenship-statistic",
        meta: true,
        component: () => import("@/pages/corporate/citizenship-statistic/index.vue")
    }
];
